import { render, staticRenderFns } from "./PartesPage.vue?vue&type=template&id=47e8a57b"
import script from "./PartesPage.vue?vue&type=script&lang=js"
export * from "./PartesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports